import { render, staticRenderFns } from "./Supervision.vue?vue&type=template&id=1450c945&scoped=true"
import script from "./Supervision.vue?vue&type=script&lang=js"
export * from "./Supervision.vue?vue&type=script&lang=js"
import style0 from "./Supervision.vue?vue&type=style&index=0&id=1450c945&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1450c945",
  null
  
)

export default component.exports